import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'fz-chip-group',
  standalone: true,
  templateUrl: './chip-group.html',
  styleUrls: ['./chip-group.scss'],
  host: {
    class: 'fz-chip-group',
    '[class.fz-chip-group--scrollable]': 'scrollable',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ChipGroup {
  /**
   * If true, the chip group will be scrollable.
   */
  @Input() scrollable = false;
}
